import { z } from 'zod';
/**
 * Attachment descriptor — does NOT carry bytes. The raw bytes live in the
 * BlobStore, referenced by `blobRef`. `contentHashSha256` lets us dedupe and
 * verify on re-fetch.
 */
export const AttachmentSchema = z.object({
    id: z.guid(),
    filename: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    blobRef: z.string().min(1),
    contentHashSha256: z.string().regex(/^[a-f0-9]{64}$/, 'must be lowercase hex sha256'),
    inline: z.boolean().default(false),
    /**
     * Free-form adapter-specific metadata. Persisted as-is to `attachment.meta`
     * (jsonb). Used today by the Gmail poller to flag bytes-download failures
     * (`{ ingestion_failed: true, error: '...' }`), so the admin-api can return
     * 410 Gone instead of 404 when the row references a blob that was never
     * uploaded. Keep keys snake_case for consistency with the DB.
     */
    meta: z.record(z.string(), z.unknown()).default({}),
});
//# sourceMappingURL=attachment.js.map